<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Relatório de Produtos Vendidos</h1>
    <span *ngIf="carregado" class="badge bg-secondary">Total: {{ produtos.length }}</span>
  </div>
  <hr />

  <!-- Filtros -->
  <div class="row g-2 align-items-end mb-3 no-print">
    <div class="col-md-3">
      <label class="form-label">Data Inicial <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataInicialInvalida"
             [(ngModel)]="dataInicial" />
      <div class="invalid-feedback" *ngIf="dataInicialInvalida">
        Informe a data inicial.
      </div>
    </div>
    <div class="col-md-3">
      <label class="form-label">Data Final <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataFinalInvalida"
             [(ngModel)]="dataFinal" />
      <div class="invalid-feedback" *ngIf="dataFinalInvalida">
        Informe a data final.
      </div>
    </div>
    <div class="col-md-3 ms-md-auto d-flex gap-2">
      <button class="btn btn-primary w-100" (click)="buscar()" [disabled]="carregando">
        <span *ngIf="carregando" class="spinner-border spinner-border-sm me-1"></span>
        Buscar
      </button>
      <button class="btn btn-outline-secondary w-100" (click)="limpar()" [disabled]="carregando">
        Limpar
      </button>
    </div>
  </div>

  <div class="alert alert-warning no-print mb-3"
       *ngIf="tentouBuscar && (!dataInicial || !dataFinal)">
    Informe a data inicial e a data final para gerar o relatório.
  </div>

  <div *ngIf="carregando" class="alert alert-info no-print" role="alert">
    Carregando relatório...
  </div>

  <!-- Resultados -->
  <div *ngIf="carregado">

    <div class="d-flex justify-content-end mb-2 no-print">
      <button class="btn btn-outline-dark btn-sm" (click)="imprimir()">Imprimir Relatório</button>
    </div>

    <!-- Cabeçalho visível apenas na impressão -->
    <div class="print-header print-only">
      <div class="print-header-title">Relatório de Produtos Vendidos</div>
      <div class="print-header-meta">
        <span>
          Período: {{ formatDate(dataInicial) }} a {{ formatDate(dataFinal) }}
        </span>
        <span class="print-header-sep"> | Total: {{ produtos.length }} produto(s)</span>
        <span class="print-header-sep"> | Gerado em: {{ dataGeracao }}</span>
      </div>
      <div class="print-header-divider"></div>
    </div>

    <div *ngIf="produtos.length === 0" class="text-center text-muted py-4">
      Nenhum produto vendido encontrado para o período selecionado.
    </div>

    <div class="table-responsive" *ngIf="produtos.length > 0">
      <table class="table table-striped table-hover print-table">
        <thead class="table-dark">
          <tr>
            <th scope="col">Produto</th>
            <th scope="col">Tipo</th>
            <th scope="col" class="text-center">Unidade Medida</th>
            <th scope="col" class="text-end">Qtd. Vendido no Mês</th>
            <th scope="col" class="text-center">Mês de Referência</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let prod of produtos">
            <td>{{ prod.nomeProduto }}</td>
            <td>{{ prod.tipo }}</td>
            <td class="text-center">{{ prod.dimensaoUnitariaM2 }}</td>
            <td class="text-end">{{ prod.qtdM2VendidoMes | number:'1.2-2' }}</td>
            <td class="text-center">{{ formatMesReferencia(prod.mesReferencia) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="print-totals">
            <td colspan="3" class="text-end fw-bold">Total:</td>
            <td class="text-end fw-bold">{{ totalM2Vendido | number:'1.2-2' }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>
